import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

const calculatorImages: Record<string, string> = import.meta.glob(
	'@/assets/landing/calorie-deficit/calculator-*.webp',
	{
		eager: true,
		import: 'default',
	},
)

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingImage', 'LandingProgressLoader', 'LandingFooter'],

	components: {
		LandingImage: ({ ctx, $t }): LandingComponentsConfig['LandingImage'] => {
			const img =
				Object.entries(calculatorImages).find(([k]) => k.includes(`calculator-${ctx.language}.webp`))?.[1] ??
				Object.entries(calculatorImages).find(([k]) => k.includes('calculator-en.webp'))?.[1]

			return {
				img,
				overlayText: {
					title: $t('pages.landing.calorie_deficit_calculator_title'),
					subtitle: $t('pages.landing.calorie_deficit_calculator_subtitle'),
				},
				customStyles: {
					maxWidth: '420px',
				},
			}
		},

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
